// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-light: #eef2ff;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #9ca3af;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s ease;
}

.view-add-doc-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
  width: 100%;
  align-items: flex-start;
}

.view-add-doc-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  width: 100%;
  padding: 2rem;
  transition: var(--transition);
}

.view-add-doc-header {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1.5rem;
}

.avatar {
  width: 64px;
  height: 64px;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: bold;
  margin-right: 1.5rem;
  text-transform: uppercase;
}

.view-add-doc-title h2 {
  margin: 0;
  font-size: 1.5rem;
  color: var(--text-dark);
  font-weight: 600;
}

.view-add-doc-tag {
  display: inline-block;
  margin-top: 0.5rem;
  background-color: var(--primary-light);
  color: var(--primary-color);
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  cursor: pointer;
}

.view-add-doc-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 0.8rem;
  margin-bottom: 1.5rem;
}

.view-note-detail-item {
  display: flex;
  gap: 1rem;
}
.view-note-detail-item .icon {
  font-size: 1.25rem;
  color: var(--primary-color);
  margin-top: 0.25rem;
  flex-shrink: 0;
}
.view-note-detail-item label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: var(--text-light);
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.view-note-detail-item p {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text-dark);
}

.view-add-doc-description {
  font-size: 0.95rem;
  color: var(--text-medium);
  margin-top: 1rem;
  line-height: 1.6;
}

.view-add-doc-document {
  margin-top: 0.5rem;
}
.view-add-doc-document a {
  font-weight: 500;
  color: var(--primary-color);
  text-decoration: underline;
}
.view-add-doc-document a:hover {
  text-decoration: none;
}
.view-add-doc-document .view-doc-button {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.95rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(67, 97, 238, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 2rem auto;
}

.error-message {
  text-align: center;
  color: var(--danger-color);
  font-weight: 500;
  font-size: 1rem;
  padding: 2rem;
  width: 100%;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .view-add-doc-detail-container {
    padding: 1rem;
  }
  .view-add-doc-card {
    padding: 1.5rem;
  }
  .view-add-doc-details-grid {
    grid-template-columns: 1fr;
  }
}
.upload-section {
  margin-top: 20px;
}
.upload-section .upload-section-header {
  margin-bottom: 12px;
}
.upload-section .upload-section-header strong {
  font-size: 0.95rem;
  color: var(--text-dark);
  font-weight: 500;
}
.upload-section .upload-methods {
  margin-bottom: 16px;
}
.upload-section .upload-methods .upload-modal-btn {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.95rem;
}
.upload-section .upload-box {
  border: 2px dashed #ccc;
  padding: 20px;
  cursor: pointer;
  text-align: center;
}
.upload-section .upload-result {
  margin-top: 0.5rem;
}
.upload-section .upload-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.upload-section .upload-progress {
  margin-top: 10px;
}
.upload-section .upload-progress .progress-bar {
  background: #eee;
  height: 6px;
  border-radius: 4px;
  overflow: hidden;
}
.upload-section .upload-progress .progress-fill {
  background: #4caf50;
  height: 100%;
  transition: width 0.3s ease;
}
.upload-section .upload-progress .percent-upload {
  margin-top: 0.5rem;
}
.upload-section .upload-actions {
  display: flex;
  justify-content: end;
  gap: 10px;
  margin-top: 0.5rem;
}
.upload-section .upload-actions button {
  padding: 6px 12px;
  color: #fff;
  font-weight: 600;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.upload-section .upload-actions .cancel-btn {
  background: #ff5e5e;
}
.upload-section .upload-actions .submit-btn {
  background: #4caf50;
}

.view-note-detail-item.clickable {
  cursor: pointer;
}

.court-ref-tooltip {
  text-decoration: underline;
  color: #0066cc;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/ViewAdditionalDoc/ViewAdditionalDoc.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4CAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;AACF;;AAEA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;AACF;;AAGE;EACE,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,qBAAA;EACA,kBAAA;EACA,sCAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;EACA,qBAAA;AADF;;AAIA;EACE,aAAA;EAEA,SAAA;AAFF;AAIE;EACE,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AAFJ;AAKE;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;AAHJ;AAME;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAJJ;;AAQA;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AALF;;AAQA;EACE,kBAAA;AALF;AAOE;EACE,gBAAA;EACA,2BAAA;EACA,0BAAA;AALJ;AAOI;EACE,qBAAA;AALN;AASE;EACE,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;AAPJ;;AAcA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;AAXF;;AAcA;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AAXF;;AAcA;EACE;IACE,yBAAA;EAXF;AACF;AAcA;EACE;IACE,aAAA;EAZF;EAeA;IACE,eAAA;EAbF;EAgBA;IACE,0BAAA;EAdF;AACF;AAiBA;EACE,gBAAA;AAfF;AAiBE;EACE,mBAAA;AAfJ;AAiBI;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;AAfN;AAmBE;EACE,mBAAA;AAjBJ;AAmBI;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;AAjBJ;AAqBE;EACE,uBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AAnBJ;AAwBE;EACE,kBAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAvBJ;AA0BE;EACE,gBAAA;AAxBJ;AA0BI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAxBN;AA2BI;EACE,mBAAA;EACA,YAAA;EACA,2BAAA;AAzBN;AA2BI;EACE,kBAAA;AAzBN;AA6BE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;AA3BJ;AA6BI;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA3BN;AA8BI;EACE,mBAAA;AA5BN;AA+BI;EACE,mBAAA;AA7BN;;AAkCA;EACE,eAAA;AA/BF;;AAkCA;EACE,0BAAA;EACA,cAAA;EACA,eAAA;AA/BF","sourcesContent":[":root {\r\n  --primary-light: #eef2ff;\r\n  --success-color: #10b981;\r\n  --danger-color: #ef4444;\r\n  --text-dark: #1f2937;\r\n  --text-medium: #4b5563;\r\n  --text-light: #9ca3af;\r\n  --bg-light: #f9fafb;\r\n  --card-bg: #ffffff;\r\n  --border-radius: 12px;\r\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\r\n  --transition: all 0.3s ease;\r\n}\r\n\r\n.view-add-doc-detail-container {\r\n  padding: 1rem;\r\n  background-color: #f4f6f8;\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: flex-start;\r\n}\r\n\r\n.view-add-doc-card {\r\n  background-color: var(--card-bg);\r\n  border-radius: var(--border-radius-primary);\r\n  box-shadow: var(--box-shadow);\r\n  width: 100%;\r\n  padding: 2rem;\r\n  transition: var(--transition);\r\n}\r\n\r\n.view-add-doc-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n  border-bottom: 1px solid #eee;\r\n  padding-bottom: 1.5rem;\r\n}\r\n\r\n.avatar {\r\n  width: 64px;\r\n  height: 64px;\r\n  background-color: var(--primary-light);\r\n  color: var(--primary-color);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.75rem;\r\n  font-weight: bold;\r\n  margin-right: 1.5rem;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.view-add-doc-title {\r\n  h2 {\r\n    margin: 0;\r\n    font-size: 1.5rem;\r\n    color: var(--text-dark);\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.view-add-doc-tag {\r\n  display: inline-block;\r\n  margin-top: 0.5rem;\r\n  background-color: var(--primary-light);\r\n  color: var(--primary-color);\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.view-add-doc-details-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 0.8rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.view-note-detail-item {\r\n  display: flex;\r\n  // align-items: center;\r\n  gap: 1rem;\r\n\r\n  .icon {\r\n    font-size: 1.25rem;\r\n    color: var(--primary-color);\r\n    margin-top: 0.25rem;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  label {\r\n    display: block;\r\n    font-size: 0.75rem;\r\n    text-transform: uppercase;\r\n    color: var(--text-light);\r\n    letter-spacing: 0.5px;\r\n    margin-bottom: 0.25rem;\r\n  }\r\n\r\n  p {\r\n    margin: 0;\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n    color: var(--text-dark);\r\n  }\r\n}\r\n\r\n.view-add-doc-description {\r\n  font-size: 0.95rem;\r\n  color: var(--text-medium);\r\n  margin-top: 1rem;\r\n  line-height: 1.6;\r\n}\r\n\r\n.view-add-doc-document {\r\n  margin-top: 0.5rem;\r\n  \r\n  a {\r\n    font-weight: 500;\r\n    color: var(--primary-color);\r\n    text-decoration: underline;\r\n\r\n    &:hover {\r\n      text-decoration: none;\r\n    }\r\n  }\r\n\r\n  .view-doc-button {\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    padding: 0.5rem 1.5rem;\r\n    border-radius: 6px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: var(--transition);\r\n    font-size: 0.95rem;\r\n\r\n\r\n    \r\n  }\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid rgba(67, 97, 238, 0.2);\r\n  border-top-color: var(--primary-color);\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin: 2rem auto;\r\n}\r\n\r\n.error-message {\r\n  text-align: center;\r\n  color: var(--danger-color);\r\n  font-weight: 500;\r\n  font-size: 1rem;\r\n  padding: 2rem;\r\n  width: 100%;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .view-add-doc-detail-container {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .view-add-doc-card {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .view-add-doc-details-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.upload-section {\r\n  margin-top: 20px;\r\n\r\n  .upload-section-header {\r\n    margin-bottom: 12px;\r\n    \r\n    strong {\r\n      font-size: 0.95rem;\r\n      color: var(--text-dark);\r\n      font-weight: 500;\r\n    }\r\n  }\r\n\r\n  .upload-methods {\r\n    margin-bottom: 16px;\r\n    \r\n    .upload-modal-btn {\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    padding: 0.5rem 1.5rem;\r\n    border-radius: 6px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: var(--transition);\r\n    font-size: 0.95rem;\r\n    }\r\n  }\r\n\r\n  .upload-box {\r\n    border: 2px dashed #ccc;\r\n    padding: 20px;\r\n    cursor: pointer;\r\n    text-align: center;\r\n\r\n\r\n  }\r\n\r\n  .upload-result {\r\n    margin-top: 0.5rem;\r\n  }\r\n\r\n  .upload-icon {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 8px;\r\n  }\r\n\r\n  .upload-progress {\r\n    margin-top: 10px;\r\n\r\n    .progress-bar {\r\n      background: #eee;\r\n      height: 6px;\r\n      border-radius: 4px;\r\n      overflow: hidden;\r\n    }\r\n\r\n    .progress-fill {\r\n      background: #4caf50;\r\n      height: 100%;\r\n      transition: width 0.3s ease;\r\n    }\r\n    .percent-upload{\r\n      margin-top: 0.5rem;\r\n    }\r\n  }\r\n\r\n  .upload-actions {\r\n    display: flex;\r\n    justify-content: end;\r\n    gap: 10px;\r\n    margin-top: 0.5rem;\r\n\r\n    button {\r\n      padding: 6px 12px;\r\n      color: #fff;\r\n      font-weight: 600;\r\n      border: none;\r\n      border-radius: 5px;\r\n      cursor: pointer;\r\n    }\r\n\r\n    .cancel-btn {\r\n      background: #ff5e5e;\r\n    }\r\n\r\n    .submit-btn {\r\n      background: #4caf50;\r\n    }\r\n  }\r\n}\r\n\r\n.view-note-detail-item.clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.court-ref-tooltip {\r\n  text-decoration: underline;\r\n  color: #0066cc;\r\n  cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
